import React from "react";

const Footer = () => {
  return (
    <footer className="py-5 bg-dark text-white">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 mb-4 mb-lg-0">
            <h5 className="mb-4">
              <img
                src="/assets/images/white_logo.png"
                alt="logo"
                width="220px"
              />
            </h5>
            <p>
              Formax Pay is a leading fintech platform offering a wide range of
              services, including recharge, utility bill payments, PAN card,
              Insurance POSP and e-governance solutions.
            </p>
          </div>
          <div className="col-lg-2 col-6 mb-4 mb-lg-0">
            <h5 className="mb-4">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a href="#features" className="text-white">
                  Features
                </a>
              </li>
              <li className="mb-2">
                <a href="#screenshots" className="text-white">
                  Screenshots
                </a>
              </li>
              <li className="mb-2">
                <a href="#download" className="text-white">
                  Download
                </a>
              </li>
              <li className="mb-2">
                <a href="#faq" className="text-white">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 col-6 mb-4 mb-lg-0">
            <h5 className="mb-4">Legal</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a
                  href="https://www.formaxpay.com/privacy-policy"
                  target="_blank"
                  className="text-white"
                >
                  Privacy Policy
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="https://www.formaxpay.com/terms-and-conditions"
                  target="_blank"
                  className="text-white"
                >
                  Terms of Service
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="https://www.formaxpay.com/refund-policy"
                  target="_blank"
                  className="text-white"
                >
                  Refund Policy
                </a>
              </li>
            </ul>
          </div>
          <div className="col-lg-3">
            <h5 className="mb-4">Contact Us</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <i className="fas fa-envelope mr-2"></i> helpdesk@formaxpay.com
              </li>
              <li className="mb-2">
                <i className="fab fa-whatsapp mr-2"></i> +91 78900-90-500
              </li>
              <li className="mb-2">
                <i class="fas fa-map-marker-alt mr-2"></i> Barasat, Kolkata -
                700126
              </li>
            </ul>
          </div>
        </div>
        <hr className="bg-light my-4" />
        <div className="row">
          <div className="col-md-6 text-center text-md-left">
            <p className="mb-0 small">
              Copyright © 2025 Formax IT Solutions Private Limited | All Rights
              Reserved.
            </p>
          </div>
          <div className="col-md-6 text-center text-md-right">
            <a
              href="https://www.facebook.com/formaxitsolutions"
              target="_blank"
              className="text-white mx-2"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://www.instagram.com/formaxpay/"
              target="_blank"
              className="text-white mx-2"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://www.whatsapp.com/channel/0029VarIaITCXC3I79aDXH2Y"
              target="_blank"
              className="text-white mx-2"
            >
              <i className="fab fa-whatsapp"></i>
            </a>
            <a
              href="https://www.youtube.com/@formaxitsolutionsprivateli2676"
              target="_blank"
              className="text-white mx-2"
            >
              <i className="fab fa-youtube"></i>
            </a>
            <a
              href="https://t.me/formaxpay"
              target="_blank"
              className="text-white mx-2"
            >
              <i className="fab fa-telegram"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
